<template>
  <div class="fixed bg-primary sm:top-0 right-0 bottom-0 w-16 p-4 z-50" v-if="isLocal">
    <WrenchIcon class="h-8 text-foreground" />
  </div>
  <div class="fixed sm:top-0 right-0 bottom-0 w-16 p-4 bg-primary z-50" v-if="isTest">
    <PuzzlePieceIcon class="h-8 text-septenary" />
  </div>
</template>
<script setup>
import { isLocal, isTest } from "@/config";
import { WrenchIcon } from "@heroicons/vue/24/outline";
import { PuzzlePieceIcon } from "@heroicons/vue/24/outline";
</script>
